import React, { useState, useEffect } from "react";
import { TableRow, TableCell, Tooltip } from "@mui/material";
import { NameTableCell, MessageTableCell, DateTableCell, StatusTableCell } from "./tableCells";
import { AccessTime as AccessTimeIcon } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import routes from "../api/routes";


const ArchiveCard = ({ event }) => {
  const [status, setStatus] = useState(null);
      const history = useHistory();
  

  useEffect(() => {
    setStatus(event.status);
  }, [event]);

  const handleRowClick = () => {
      history.push({
          pathname: routes.viewEvent.path("email", event._id),
          state: { eventData: event }
      });
  };
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const renderStatus = () => {
    const getStyle = (color) => ({
      padding: "4px 8px",
      borderRadius: "5px",
      fontSize: "12px",
      border: `1px solid ${color}`,
      backgroundColor: `${color}20`,
      color: color,
      width: "80px",
      height: "24px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
    });

    if (event.scheduledTime && status === "In Progress") {
      const scheduledDate = new Date(event.scheduledTime);
      const formatted = scheduledDate.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      return (
        <Tooltip title={`Scheduled for: ${formatted}`}>
          <span style={getStyle("#ff9800")}>Scheduled</span>
        </Tooltip>
      );
    }

    switch (status) {
      case "In Progress":
        return <span style={getStyle("#42a5f5")}>In Progress</span>;
      case "Cancelled":
        return <span style={getStyle("#ff2626ff")}>Stopped</span>;
      case "Yet to Send":
        return <span style={getStyle("#78909c")}>Not Sent</span>;
      case "Completed":
        return <span style={getStyle("#66bb6a")}>Sent</span>;
      case "Failed":
        return <span style={getStyle("#ef5350")}>Failed</span>;
      default:
        return <span style={getStyle("#ef5350")}>Failed</span>;
    }
  };

  return (
    <TableRow key={event._id} hover  onClick={handleRowClick} style={{cursor:'pointer'}}>
      <NameTableCell>{event.name}</NameTableCell>
      <MessageTableCell title={stripHtml(event.message)}>{stripHtml(event.message)}</MessageTableCell>
      <DateTableCell>
        {event.scheduledTime ? (
          <>
            <AccessTimeIcon style={{ marginRight: 3, marginBottom: 3, verticalAlign: "middle", fontSize: "1rem", color: "#666" }} />
            {new Date(event.scheduledTime).toLocaleString(undefined, {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </>
        ) : (
          new Date(event.date).toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric" })
        )}
      </DateTableCell>
      <StatusTableCell>{renderStatus()}</StatusTableCell>
    </TableRow>
  );
};

export default ArchiveCard;
